<template>
  <v-app id="login">
    <!-- <v-img src="../../assets/banner-adapt-login.jpg" max-height="700"> -->
    <v-content>
      <v-container class="fill-height" fluid>
        <v-row align="center" justify="center">
          <v-col cols="12" sm="8" md="4">
            <v-card class="elevation-12">
              <v-toolbar :color="color" dark flat>
                <v-toolbar-title>Adapt - Analytics</v-toolbar-title>
                <v-spacer></v-spacer>
              </v-toolbar>
              <v-card-text>
                <v-form ref="formLogin" v-model="valid" lazy-validation>
                  <v-text-field
                    id="email"
                    label="E-mail"
                    v-model="user.email"
                    :rules="emailValidation"
                    prepend-icon="mdi-account-lock"
                    type="text"
                    required
                    autofocus
                  ></v-text-field>
                  <v-text-field
                    id="password"
                    label="Senha"
                    v-model="user.password"
                    :rules="passwordValidation"
                    prepend-icon="mdi-lock-check"
                    type="password"
                    required
                  ></v-text-field>
                </v-form>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn :color="color" @click="logar" dark>
                  <v-icon rigth dark>mdi-check</v-icon>Login
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-content>
    <!-- </v-img> -->
  </v-app>
</template>

<script>
export default {
  created() {},
  data: () => ({
    color: "#34a95a",
    dialog: false,
    valid: true,
    emailValidation: [
      (v) => !!v || "Obrigatório informar o e-mail!",
      (v) => /.+@.+\..+/.test(v) || "E-mail inválido",
    ],
    passwordValidation: [
      (v) => (v && v.length > 6) || "Senha deve conter mais de 6 caracteres",
    ],
    user: {
      email: "",
      password: "",
    },
  }),
  props: {
    source: String,
  },
  methods: {
    logar(e) {
      e.preventDefault();
      this.$http
        .post("login", this.user)
        .then((res) => {
          const access = res.data.user.tipo;
          localStorage.setItem("user", JSON.stringify(res.data.user));
          localStorage.setItem("token", res.data.data.token);
          this.$http.defaults.headers.common[
            "Authorization"
          ] = `Bearer ${res.data.data.token}`;
          if (localStorage.getItem("token") != null) {
            this.$emit("loggedIn");
            if (this.$route.params.nextUrl != null) {
              this.$router.push(this.$route.params.nextUrl);
            } else {
              if (access === "root") {
                this.$router.push("dashboard");
              } else if (access === "supervisor") {
                this.$router.push("dashboard");
              } else if (access === "basico") {
                this.$router.push("dashboard");
              }
            }
          }
        })
        .catch(function (error) {
          if (error.res) {
            alert(`Não autorizado: Email e/ou senha incorretos`);
          }
          alert(`Não autorizado: Email e/ou senha incorretos`);
        });
    },
  },
};
</script>